<template>
  <div>
    <b-card>
      <div slot="header" v-if="!add && lock">
        CRS Detail
      </div>
      <div slot="header" v-if="!add && !lock">
        Modify CRS
      </div>
      <div slot="header" v-if="add && !lock">
        Create CRS
      </div>

      <b-row>
        <b-col md="3">
          <b-form-group class="text-primary" label="Active Use" label-for="ph_is_use">
            <c-switch color="info" label size="lg" id="ph_is_use" v-model="model.is_use" :disabled="lock" />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group class="text-primary" label="Active Publish" label-for="ph_is_publish">
            <c-switch color="info" label size="lg" id="ph_is_publish" v-model="model.is_publish" :disabled="lock" />
          </b-form-group>
        </b-col>
        <b-col md="2"> OWASP Year </b-col>
        <b-col md="4">
          <b-input type="long" v-model="model.owasp_year" :plaintext="lock"></b-input>
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col md="2"> Registed_at </b-col>
        <b-col md="4">
          <!-- <date-picker v-if="!lock" v-model="model.created_at" type="datetime" class="mb-2"></date-picker> -->
          <b-input type="datetime" v-bind:value="model.updated_at | datetime" plaintext></b-input>
        </b-col>
        <b-col md="2"> Last Changed </b-col>
        <b-col md="4">
          <!-- <date-picker v-if="!lock" v-model="model.updated_at" type="datetime" class="mb-2"></date-picker> -->
          <b-input type="datetime" v-bind:value="model.updated_at | datetime" plaintext></b-input>
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col md="2"> Version(CRS + Vender Rule) </b-col>
        <b-col md="4">
          <b-input type="datetime" v-model="model.version" :plaintext="lock"></b-input>
        </b-col>
        <b-col md="2"> Agent Version </b-col>
        <b-col md="4">
          <b-input type="datetime" v-model="model.agent_version" :plaintext="lock"></b-input>
        </b-col>
      </b-row>
      <hr>
      <b-row class="text-center font-weight-bold">
        <b-col>
          Policy
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col lg="12" xl="6">
          <b-card>
            <div class="d-flex flex-wrap align-items-center">
              <div class="title mr-auto">
                CRS RULE
              </div>
            </div>
            <hr>
            <codemirror :disabled="lock" v-model="model.crs_rule" :options="options_json" @input="change_rule" />
            <!-- <b-textarea style="min-height: 500px;" @change="change" type="text" v-model="model.crs_rule" :plaintext="lock" rows="1"></b-textarea> -->
          </b-card>
        </b-col>
        <b-col lg="12" xl="6">
          <b-card>
            <div class="d-flex flex-wrap align-items-center">
              <div class="title mr-auto">
                CRS RULE JSON :
                <b-badge variant="success" v-if="json_validation">Good</b-badge>
                <b-badge v-else variant="secondary">Bad Json format</b-badge>
              </div>
            </div>
            <hr>
            <codemirror :disabled="lock" v-model="model.crs_json" :options="options_json" @input="change_json" />
            <!-- <b-textarea style="min-height: 500px;" @change="change_json" type="text" v-bind:value="(typeof '' == typeof model.crs_json ? model.crs_json : JSON.stringify(model.crs_json))" :plaintext="lock" rows="1"></b-textarea> -->
          </b-card>
        </b-col>
      </b-row>

      <hr>
      <b-button size="sm" variant="light" @click="back"> Back </b-button>
      <template v-if="lock">
        <div class="float-right">
          <b-button class= "mr-1" size="sm" variant="primary" @click="edit"> Modify </b-button>
          <b-button size="sm" variant="danger" @click="confirm = true"> Delete </b-button>
        </div>
      </template>
      <template v-else>
        <div class="float-right">
          <b-button class="mr-1" size="sm" variant="danger" @click="cancel"> Cancel </b-button>
          <b-button size="sm" variant="primary" @click="save"> Save </b-button>
        </div>
      </template>
    </b-card>
    <b-modal title="Confirm - Delete user account" class="modal-danger" v-model="confirm" @ok="remove" ok-variant="danger">
      Deleted data cannot be reversed. Are you sure?
    </b-modal>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import { Switch as cSwitch } from '@coreui/vue';
import { api, auth } from '@/f1/service';
// import reg from '@/f1/reg'
import moment from 'moment-timezone';
import DatePicker from 'vue2-datepicker'
import 'vue-select/dist/vue-select.css';
import { codemirror } from "vue-codemirror"
// 기본 css style import
import "codemirror/lib/codemirror.css"

// import dedent from 'dedent'
// require styles
import 'codemirror/lib/codemirror.css'
// theme css
import 'codemirror/theme/base16-dark.css'

// language
import 'codemirror/mode/vue/vue.js'

import 'codemirror/addon/scroll/annotatescrollbar.js'
import 'codemirror/addon/search/matchesonscrollbar.js'
import 'codemirror/addon/search/searchcursor.js'
import 'codemirror/addon/search/match-highlighter.js'
// keyMap
import 'codemirror/mode/clike/clike.js'
import 'codemirror/addon/edit/matchbrackets.js'
import 'codemirror/addon/comment/comment.js'
import 'codemirror/addon/dialog/dialog.js'
import 'codemirror/addon/dialog/dialog.css'
import 'codemirror/addon/search/searchcursor.js'
import 'codemirror/addon/search/search.js'
import 'codemirror/keymap/sublime.js'
// foldGutter
import 'codemirror/addon/fold/foldgutter.css'
import 'codemirror/addon/fold/brace-fold.js'
import 'codemirror/addon/fold/comment-fold.js'
import 'codemirror/addon/fold/foldcode.js'
import 'codemirror/addon/fold/foldgutter.js'
import 'codemirror/addon/fold/indent-fold.js'
import 'codemirror/addon/fold/markdown-fold.js'
import 'codemirror/addon/fold/xml-fold.js'

// import { install as VueMonacoEditorPlugin } from '@guolao/vue-monaco-editor'
// import { loader } from "@guolao/vue-monaco-editor"

const default_model = () => ({
  is_alive : true,
  is_published : false,
  crs_rule : '',
  crs_json : '',
  agent_version : '',
  version : '',
  usage : 0,
});

export default {
  components: { cSwitch, vSelect, DatePicker, moment, codemirror },
  data : () => ({
    json_validation : false,
    options_rule: {
      tabSize: 4,
      // mode: 'text',
      theme: 'base16-dark',
      lineNumbers: true,
      line: true,
      mode: 'text/javascript',
      lineWrapping: true,
    },
    options_json: {
      tabSize: 4,
      theme: 'base16-dark',
      lineNumbers: true,
      line: true,
      mode: 'text/javascript',
      lineWrapping: true,
    },
    confirm: false,
    add: false,
    lock: true,
    model : default_model(),
    profile: auth.profile,
  }),
  computed: {
    // last_info() { return `${this.$options.filters.sdate(this.model.last_visit)} @ ${this.model.last_addr}`; }
  },
  methods: {
    change_rule(content) {
      this.model = Object.assign({}, this.model, { crs_rule : content })
    },
    change_json(content) {
      this.model = Object.assign({}, this.model, { crs_json : content })
      this.json_validation = true
      try { JSON.parse(content.toString())  } catch (e) { console.log("is not json format"); this.json_validation = false }

    },
    // formatter(value){ return value.replace(/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/g, '' ); },
    cancel() { this.$router.replace({ name: 'uwss_crs', params: { id: this.model.id }}); },
    edit() { this.$router.replace({ name: 'uwss_crs', params: { id: this.model.id, tag: 'edit' }}); },
    async remove() {
      try {
        await api.uwss.crs.delete(this.model.id);
        this.$emit('refresh'); this.$toastr.s('uwss_crs deleted.'); this.list();
      } catch(e) { this.$toastr.e(e.data || e); this.list(); }
    },
    back() { this.$router.go(-1); },
    list() { this.$router.push({ name: 'uwss_crs'}); },
    async save() {
      try {
        if(!(this.model.version || '')) { return this.$toastr.e('Expire required.'); }
        if(!(this.model.agent_version || '')) { return this.$toastr.e('Expire required.'); }
        if(!(this.model.crs_rule || '')) { return this.$toastr.e('Expire required.'); }
        if(!(this.model.crs_json || '')) { return this.$toastr.e('Expire required.'); }
        if(!this.json_validation) { return this.$toastr.e("Rule JSON", "require json format") }

        if(this.model.id) {
          // await api.uwss.crs.update( Object.assign({}, this.model, { crs_json: typeof '' == typeof this.model.crs_json ? this.model.crs_json : JSON.stringify(this.model.crs_json) }));
          await api.uwss.crs.update(this.model);
        }
        else {
          this.model.id = +(await api.uwss.crs.add(this.model));
        }
        this.$toastr.s('Done.'); this.$emit('refresh'); this.cancel();
      } catch(e) { this.$toastr.e(e.data || e); this.cancel(); }
      this.lock = true;
    },
    async get({ id, tag } = this.$route.params) {
      console.log('[vue] crs.detail', 'load item', id);

      if(id === 'add') { this.add = true; this.lock = false; this.model = default_model(); return; }
      else { this.add = false; }

      this.lock = (tag !== 'edit');
      try {
        this.model = Object.assign({}, this.model, await api.uwss.crs.get(id));
        // this.model.crs_json = typeof '' == typeof this.model.crs_json ? this.model.crs_json : JSON.stringify(this.model.crs_json)
       }
      catch(e) { console.log(e); this.$toastr.e(e.data || e); this.list(); }
    }
  },
  watch: { '$route' (to, from) { this.get(to.params); console.log(from) } },
  created() { },
  destroyed() { },
  mounted() {
    this.get(this.$route.params);
  }
}
</script>
